import { render, staticRenderFns } from "./TemplateLanding.vue?vue&type=template&id=1037a5d4&"
import script from "./TemplateLanding.vue?vue&type=script&lang=js&"
export * from "./TemplateLanding.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLanding.vue?vue&type=style&index=0&id=1037a5d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionsLandingSectionSelector: require('/app/components/sections/landing/SectionSelector.vue').default})
